import { post, get, put, createApiUrl } from './baseApi';

// 스포츠 관련
export function getSportsBaseList() {
    const request = createApiUrl("/api/v1/admin/sports/base/list");
    return get(request);
}

export function putSportsSetting(setting) {
    const request = createApiUrl("/api/v1/admin/user/sports/setting");
    return put(request, setting);
}

export function putSportsPer(sportsPer) {
    const request = createApiUrl("/api/v1/admin/user/sports/per");
    return put(request, sportsPer);
}

export function putSportScore(score) {
    const request = createApiUrl("/api/v1/admin/sports/score");
    return put(request, score);
}

export function getSportsConfig(params) {
    const request = createApiUrl("/api/v1/admin/sports/config/list");
    return post(request, params);
}

export function getCompanyBaseSetting(companyCode) {
    const request = createApiUrl("/api/v1/admin/sports/setting/" + companyCode);
    return get(request);
}

export function putCompanyBaseSetting(setting) {
    const request = createApiUrl("/api/v1/admin/sports/setting/base");
    return put(request, setting);
}

export function putCompanySportJoint(joint) {
    const request = createApiUrl("/api/v1/admin/sports/setting/joint");
    return put(request, joint);
}

export function saveCompanyGameBonusSetting(params) {
    const request = createApiUrl("/api/v1/admin/sports/setting/bonus");
    return put(request, params);
}

// 종목 관리
export function getCompanySportList(params) {
    const companyCode = params.companyCode;
    const request = createApiUrl("/api/v1/admin/sports/event/company/" + companyCode + "/separated");
    return get(request);
}

export function setCompanySports(companyCode, sports, userName) {
    const request = createApiUrl("/api/v1/admin/sports/event/company/" + companyCode + "/bulk");
    return put(request, sports, { params: { userName: userName } });
}

// 리그 관리
export function getCompanyLeagueSport(params) {
    const companyCode = params.companyCode;
    const sport = params.sport;
    const request = createApiUrl("/api/v1/admin/sports/league/company/" + companyCode + "/sport/" + sport + "/separated");
    return get(request);
}

export function setCompanyLeague(companyCode, leagues, sport, userName) {
    const request = createApiUrl("/api/v1/admin/sports/league/company/" + companyCode + "/" + sport + "/bulk");
    return put(request, leagues, { params: { userName: userName } });
}

// 미니게임 관련
export function getDhPowerballOdds(companyCode, minigame) {
    const request = createApiUrl("/api/v1/admin/minigame/" + companyCode + "/" + minigame + "/hole/odd/list");
    return get(request);
}

export function getDhPowerballResultList(params) {
    const request = createApiUrl("/api/v1/admin/minigame/powerball/results");
    return post(request, params);
}

export function getDhPowerLadderResultList(params) {
    const request = createApiUrl("/api/v1/admin/minigame/powerladder/results");
    return post(request, params);
}

export function updateDhPowerballResult(result) {
    const request = createApiUrl("/api/v1/admin/minigame/powerball/result");
    return put(request, result);
}

export function updateDhPowerLadderResult(result) {
    const request = createApiUrl("/api/v1/admin/minigame/powerladder/result");
    return put(request, result);
}

export function getCompanyMinigameLevelSetting(params) {
    const request = createApiUrl("/api/v1/admin/minigame/level/setting");
    return post(request, params);
}

export function saveCompanyMinigameLevelSetting(params) {
    const request = createApiUrl("/api/v1/admin/minigame/level/setting/save");
    return put(request, params);
}

export function getMinigameHoleList(companyCode, minigame) {
    const request = createApiUrl("/api/v1/admin/minigame/" + companyCode + "/" + minigame + "/hole/list");
    return get(request);
}

export function saveMinigameHoleList(params) {
    const request = createApiUrl("/api/v1/admin/minigame/hole/save");
    return put(request, params);
}

export function saveMinigameHoleOddList(params) {
    const request = createApiUrl("/api/v1/admin/minigame/hole/odd/save");
    return put(request, params);
}

export function getMinigameList() {
    const request = createApiUrl("/api/v1/admin/minigame/list");
    return get(request);
}

export function saveMinigameList(params) {
    const request = createApiUrl("/api/v1/admin/minigame/save");
    return put(request, params);
}

export function getMiracleGameResult(params) {
    const request = createApiUrl("/api/v1/admin/minigame/miracle/games/result");
    return post(request, params);
}

// 게임 목록
export function getGameList(companyCode, gameDiv) {
    const request = createApiUrl("/api/v1/admin/game/" + companyCode + "/" + gameDiv + "/list");
    return get(request);
}

export function getGameListAll(companyCode) {
    const request = createApiUrl("/api/v1/admin/game/" + companyCode + "/list");
    return get(request);
}

export function saveGameList(data) {
    const request = createApiUrl("/api/v1/admin/game/save");
    return put(request, data);
}

// 인플레이 게임 관리
export function getInplayGameList(companyCode) {
    const request = createApiUrl("/api/v1/admin/game/" + companyCode + "/inplay/list");
    return get(request);
}

export function saveInplayGameList(data) {
    const request = createApiUrl("/api/v1/admin/game/inplay/save");
    return put(request, data);
}

// 인플레이 마켓 관리
export function getCompanySportsInplayMarketList(companyCode, sport) {
    const request = createApiUrl("/api/v1/admin/game/" + companyCode + "/inplay/market/list");
    return get(request, { sport: sport });
}

export function saveCompanySportsInplayMarketList(data) {
    const request = createApiUrl("/api/v1/admin/game/inplay/market/save");
    return put(request, data);
}
